import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-meters',
  imports: [UnderConstructionComponent],
  templateUrl: './meters.component.html'
})
export class MetersComponent {}
